





























import { Job } from '@/types/Jobs'
import { Vue, Component, Prop } from 'vue-property-decorator'
import GMap from '@/components/GMap.vue'

@Component({
  components: {
    GMap,
  },
})
export default class JobPreview extends Vue {
  @Prop({ required: true }) job!: Job

  get countShifts() {
    return this.job.shifts?.length || null
  }
}
